'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');
var _glamorous = require('glamorous');
var _glamorous2 = _interopRequireDefault(_glamorous);
var _themes = require('@marmalade/themes');
var _helpInfo = require('@marmalade/help-info');
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _objectWithoutProperties(obj, keys) {
  var target = {};
  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }
  return target;
}
var _componentThemes$form = _themes.componentThemes.form,
  labelStyle = _componentThemes$form.labelStyle,
  formTheme = _componentThemes$form.formTheme;
var labelStyles = function labelStyles(props) {
  var theme = formTheme(props.theme);
  return {
    display: 'block',
    fontWeight: theme[labelStyle('fontWeight')]
  };
};
Label.propTypes = {
  children: _propTypes.node.isRequired,
  name: _propTypes.string.isRequired,
  helpText: _propTypes.bool
};
Label.defaultProps = {
  helpText: false
};
function Label(_ref) {
  var children = _ref.children,
    name = _ref.name,
    helpText = _ref.helpText,
    rest = _objectWithoutProperties(_ref, ['children', 'name', 'helpText']);
  return _react2.default.createElement('label', Object.assign({
    htmlFor: name
  }, rest), children, helpText && _react2.default.createElement(_helpInfo.HelpButton, {
    id: 'help-' + name,
    css: {
      float: 'right'
    }
  }));
}
exports.default = (0, _glamorous2.default)(Label)(labelStyles);